import { Instance, types } from 'mobx-state-tree';

export const StoreModel = types.model({
  id: types.string,
  name: types.string,
});

export type StoreModelType = Instance<typeof StoreModel>;
